function normalizeMessageMemoryRecallPayload(payload) {
    const items = Array.isArray(payload?.items)
        ? payload.items.map((item) => String(item || '').trim()).filter(Boolean)
        : [];
    const selection = Array.isArray(payload?.selection)
        ? payload.selection
            .map((item) => {
                if (!item || typeof item !== 'object') {
                    return null;
                }

                const text = String(item.text || item.memory_value || '').trim();
                if (!text) {
                    return null;
                }

                return {
                    id: Number.parseInt(item.id || 0, 10) || 0,
                    text,
                    category: String(item.category || 'freeform').trim(),
                    memory_key: String(item.memory_key || '').trim(),
                    memory_type_label: String(item.memory_type_label || '').trim(),
                    stability_label: String(item.stability_label || '').trim(),
                    confidence_label: String(item.confidence_label || '').trim(),
                    freshness_label: String(item.freshness_label || '').trim(),
                    why_saved: String(item.why_saved || '').trim(),
                    why_used: String(item.why_used || '').trim(),
                    status_label: String(item.status_label || '').trim(),
                };
            })
            .filter(Boolean)
        : [];

    if (items.length === 0 && selection.length === 0) {
        return null;
    }

    const normalizedItems = items.length > 0
        ? items
        : selection.map((item) => item.text);

    return {
        source: payload?.source || 'prompt_memory',
        used_for_response: payload?.used_for_response !== false,
        count: Number.parseInt(payload?.count || normalizedItems.length, 10) || normalizedItems.length,
        items: normalizedItems,
        selection,
    };
}

function buildMessageMemoryRecallBadgeLabel(payload) {
    const normalized = normalizeMessageMemoryRecallPayload(payload);

    if (!normalized) {
        return '';
    }

    if (normalized.count === 1) {
        return '1 memory used';
    }

    return `${normalized.count} memories used`;
}

function buildFriendlyMemoryRecallTitle(payload) {
    const normalized = normalizeMessageMemoryRecallPayload(payload);

    if (!normalized) {
        return 'Memory used in this reply';
    }

    if (normalized.count === 1) {
        return '1 memory helped shape this reply';
    }

    return `${normalized.count} memories helped shape this reply`;
}

function buildFriendlyMemoryRecallDescription(payload) {
    const normalized = normalizeMessageMemoryRecallPayload(payload);

    if (!normalized) {
        return '';
    }

    if (normalized.count === 1) {
        return 'This is the exact memory the assistant used from your earlier chat.';
    }

    return 'These are the exact memories the assistant used from your earlier chats.';
}

function buildMemorySettingsHref(currentUrl = '') {
    const fallbackPath = '/chat/aria-witherspoon';
    const hash = '#settings_tab-default-memories-content';

    if (typeof currentUrl !== 'string' || currentUrl.trim() === '') {
        return `${fallbackPath}${hash}`;
    }

    const trimmed = currentUrl.trim();
    const hashIndex = trimmed.indexOf('#');
    const withoutHash = hashIndex >= 0 ? trimmed.slice(0, hashIndex) : trimmed;

    return `${withoutHash}${hash}`;
}

module.exports = {
    buildMessageMemoryRecallBadgeLabel,
    buildFriendlyMemoryRecallDescription,
    buildFriendlyMemoryRecallTitle,
    buildMemorySettingsHref,
    normalizeMessageMemoryRecallPayload,
};
